import LocationTabButton from '@stories/Components/Buttons/LocationTabButton/LocationTabButton';
import * as React from 'react';
import S from './LocationTabs.styles';
const LocationTabs = ({ activeIds, onLocationChange, options, variant = 'default' }) => {
    const showAll = activeIds.length === 0;
    const handleLocationToggle = (locationValue) => {
        if (activeIds.includes(locationValue)) {
            onLocationChange(activeIds.filter(id => id !== locationValue));
        }
        else {
            onLocationChange([...activeIds, locationValue]);
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, options.label),
        React.createElement(S.Grid, null,
            React.createElement(S.AllLocationsButton, { "aria-current": showAll, onClick: () => onLocationChange([]), type: "button", "data-variant": variant }, "All Locations"),
            options.options.map((location) => (React.createElement(LocationTabButton, { key: `location-tab-${location.id}`, "aria-current": activeIds.includes(location.value), avatar: location.avatar, location: location.location, name: location.name, onClick: () => handleLocationToggle(location.value), type: "button", variant: variant }))))));
};
export default LocationTabs;
